<template>
  <div class="platform-info-edit-wrp ft-12">
    <el-form
      class="form"
      :model="self_form"
      :rules="rules"
      ref="form"
      label-width="12%"
    >
      <slot name="errMsg"></slot>
      <section>
        <div class="title ft-12">
          <span>基础信息</span>
        </div>
        <div class="conf">
          <el-form-item label="商品编码：" prop="outerProductId">
            <el-input
              type="text"
              placeholder="请输入"
              v-model="self_form.outerProductId"
              maxlength="30"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <el-form-item label="商品标题：" prop="itemName">
            <el-input
              type="text"
              placeholder="请输入"
              v-model="self_form.itemName"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <el-form-item label="分享描述：" prop="itemComment">
            <el-input
              type="text"
              placeholder="请输入"
              v-model="self_form.itemComment"
              maxlength="32"
              show-word-limit
            >
            </el-input>
            <div class="tips ft-12">微信分享给好友时会显示，建议32字以内</div>
          </el-form-item>
          <el-form-item label="商品图片：" prop="images">
            <div class="imgs-wrp">
              <MutiImgUpload
                ref="imagesRef"
                v-model="self_form.images"
                :limitWidth="[800,0]" 
                :limitHeight="[800,0]" 
                :limitSize="10 * 1024 * 1024"
                :limitNums="15"
                :size="300"
                :mainImgNums="0"
                :isCheckImg="true"
                show-audit-result
                limitSuffix=".jpg,.png,.jpeg"
                :supportAiRetry="true"
              />
              <div class="tips ft-12">
                <p>
                  <span>建议尺寸800*800像素，拖拽图片可调整顺序，最多上传15张</span>
                </p>
              </div>
            </div>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>价格库存</span>
        </div>
        <div class="conf">
          <el-form-item label="商品型号：" prop="itemType">
            <el-radio-group v-model="self_form.itemType">
              <el-radio :label="1">统一型号</el-radio>
              <el-radio :label="2">多级型号</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="self_form.itemType === 1">
            <el-form-item label="商品价格：" prop="price">
              <el-input-digit
                v-model.number="self_form.price"
                placeholder="请输入金额"
                nullable
                style="width: 150px"
              >
                <span>元</span>
              </el-input-digit>
            </el-form-item>
            <el-form-item label="商品库存：" prop="stock">
              <el-input-digit
                v-model.number="self_form.stock"
                placeholder="请输入金额"
                nullable
                :precision="0"
                style="width: 150px"
              >
                <span>件</span>
              </el-input-digit>
            </el-form-item>
            <el-form-item label="成本价：" prop="costPrice">
              <el-input-digit
                v-model.number="self_form.costPrice"
                placeholder="请输入金额"
                nullable
                style="width: 150px"
              >
                <span>元</span>
              </el-input-digit>
            </el-form-item>
          </template>
          <template v-else-if="self_form.itemType === 2"> 
            <el-form-item label="商品规格：" prop="price">
              <FormItemSpecification
                v-model="specifications"
                :changeToBase="changeToBase"
                :isPlatform="true"
                :platform="platform"
                imgLimitSuffix=".jpg"
              />
            </el-form-item>
            <el-form-item label="规格明细：" prop="price">
            <FormItemSkuList
              :specifications="specifications"
              :baseItemId="self_form.baseItemId"
              skuSpecificationsKey="skuSpecifications"
              :tableCols="skuTableCols"
              :showBindSkuOuterId="openSource !== 'shopGoods'"
              skuOuterIdKey="outSkuId"
              v-model="skuList"
              @fieldChanged="validPage"
            >
            </FormItemSkuList>
            </el-form-item>
          </template>
          <el-form-item label="划线价：" prop="crossedPrice">
            <el-input-digit
              v-model.number="self_form.crossedPrice"
              placeholder="请输入金额"
              nullable
              style="width: 150px"
            >
              <span>元</span>
            </el-input-digit>
            <div class="tips ft-12">划线价设置与展示规划，<el-link href="https://vmspub.weidian.com/gaia/50591/56945524.html?spider_token=55d6" target="_blank">点击了解</el-link></div>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>物流信息</span>
        </div>
        <div class="conf">
          <el-form-item label="物流配送：" prop="itemDelivery">
            <el-checkbox-group v-model="self_form.itemDelivery">
              <el-checkbox :label="4">快递发货</el-checkbox>
              <el-checkbox :label="8">到店自提&nbsp;<el-link href="https://d.weidian.com/weidian-pc/weidian-loader/?spider_token=9bf5#/pc-vue-oneselfLift/index" target="_blank">去设置</el-link></el-checkbox>
              <el-checkbox :label="16">同城配送&nbsp;<el-link href="https://d.weidian.com/weidian-pc/weidian-loader/#/pc-vue-localdelivery/dredgeservice" target="_blank">去设置</el-link></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="发货时间：" prop="deliveryTime" size="mini">
            <el-checkbox v-model="isCheckedDeliveryTime">设置发货时间</el-checkbox>
            <div style="padding-left: 10px;" v-if="isCheckedDeliveryTime">
              <el-radio-group v-model="deliveryTimeType">
                <div class="mb-5">
                  <el-radio :label="1">
                    付款后
                    <el-select v-model="deliveryTime.afterPayBefore" placeholder="请选择" width="100px">
                      <el-option label="次日" :value="1"></el-option>
                      <el-option label="当日" :value="2"></el-option>
                    </el-select>&nbsp;内发货
                  </el-radio>
                </div>
                <div>
                  <el-radio :label="0">
                      <el-select v-model="deliveryTime.hour" placeholder="请选择" width="100px" size="mini">
                        <el-option v-for="item in 24" :key="item" :label="item" :value="item"></el-option>
                      </el-select>&nbsp;时
                      <el-select v-model="deliveryTime.minute" placeholder="请选择" width="100px">
                        <el-option v-for="item in 60" :key="item" :label="item" :value="item"></el-option>
                      </el-select>&nbsp;分前付款，
                      <el-select v-model="deliveryTime.day" placeholder="请选择" width="100px">
                        <el-option v-for="item in deliveryTimeDays" :key="item.value" :label="item.label" :value="item.value"></el-option>
                      </el-select>&nbsp;发货
                  </el-radio>
                </div>
              </el-radio-group>
            </div>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>商品描述</span>
        </div>
        <div class="conf">
          <el-form-item label="商品描述：" prop="goodsDesc">
            <el-input
              type="textarea"
              placeholder="请输入"
              :rows="2"
              v-model="self_form.goodsDesc"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <el-form-item label="商品详情图：" prop="goodsDescImage">
            <div class="imgs-wrp">
              <MutiImgUpload
                ref="goodsDescImageRef"
                v-model="self_form.goodsDescImage"
                :limitSize="10 * 1024 * 1024"
                :limitNums="20"
                :size="300"
                :mainImgNums="0"
                limitSuffix=".jpg,.png,.jpeg"
                :supportAiRetry="true"
              />
              <div class="tips ft-12">
                <p>
                  <span>拖拽图片可调整顺序，最多上传20张</span>
                </p>
              </div>
            </div>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>上架设置</span>
        </div>
        <div class="conf">
          <el-form-item label="上架设置:" prop="onShelf">
              <el-radio-group v-model="self_form.onShelf">
                  <el-radio :label="1">立即上架</el-radio>
                  <el-radio :label="0">放入草稿箱</el-radio>
              </el-radio-group>
          </el-form-item>
        </div>
      </section>
    </el-form>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import MutiImgUpload from "@/components/Uploads/MutiImgUpload";
import { specification_mixin } from "../FormItemSpecification";
import {getDistributionConfig} from '@servers/prod/conf/index.js'
import validateMixin from '../validateMixin';
import RULES from "./rules.js";
import { cloneDeep } from 'lodash';
export default {
  mixins: [specification_mixin,validateMixin],
  inject: {
    isGroupPuhuo: { default: false },
  },
  components: {
    MutiImgUpload
  },
  props: {
    baseItemId: {
      type: String,
      default: '',
    },
    form: {
      type: Object,
      default() {
        return {};
      },
    },
    changeToBase: Function,
    openSource:{
      type:String,
      default:''
    },
  },
  data() {
    return {
        platform: "wd",
        skuSpecificationsKey: "skuSpecifications",
        self_form: {
        },
        skuTableCols: [
          {prop: 'outSkuId', attrs: {label: '商家编码'}},
          { prop: 'price', attrs: { label: '价格' },input: {type: 'number'}},
          {prop: 'stock', attrs: {label: '库存'}, input: {type: 'number'}},
        ],
        rules: RULES(this),
        checkList:[],
        isCheckedDeliveryTime:false,
        deliveryTimeType:1,
        deliveryTime:{
          hour:null,
          minute:null,
          day:null,
          afterPayBefore:null
        },
        deliveryTimeDays:[
          { value: 3600000 * 8, label: '8小时'},
          { value: 3600000 * 16, label: '16小时'},
          { value: 3600000 * 24, label: '1天'},
          { value: 3600000 * 2 * 24, label: '2天'},
          { value: 3600000 * 3 * 24, label: '3天'},
          { value: 3600000 * 4 * 24, label: '4天'},
          { value: 3600000 * 5 * 24, label: '5天'},
          { value: 3600000 * 6 * 24, label: '6天'},
          { value: 3600000 * 7 * 24, label: '7天'},
          { value: 3600000 * 15 * 24, label: '15天'},
          { value: 3600000 * 30 * 24, label: '30天'},
          { value: 3600000 * 45 * 24, label: '45天'},
        ],
        wdConfig:{},
    };
  },
  watch: {
    form: {
      handler(v) {
        const data = cloneDeep(v);
        if (data.skuList?.length) {
          data.skuList = data.skuList.map((item) => {
            const _skuid = item[this.skuSpecificationsKey].map((sp) => sp.valueKey).filter(Boolean).join("-");
            return {
              ...item,
              _skuid,
            };
          });
        }
        this.skuList = []
        if (data.specifications && data.specifications.length) {
          this.specifications = JSON.parse(JSON.stringify(data.specifications));
        }
        let itemDelivery = data.itemDelivery;
        if(itemDelivery){
          itemDelivery = itemDelivery.split(",").map(item => Number(item))
        }else{
          itemDelivery = [];
        }
        if(data.deliveryTime){
          const { deliveryTimeType,payBefore,afterPayDeliveryAt,deliveryAtAfterPayBefore } = data.deliveryTime
          this.isCheckedDeliveryTime = true
          this.deliveryTimeType = deliveryTimeType;
          if(deliveryTimeType === 0){
            const totalSeconds = Math.floor(payBefore / 1000);
            let hour = Math.floor(totalSeconds / 3600);
            let minute = Math.floor((totalSeconds%3600) / 60);
            this.deliveryTime.hour = hour
            this.deliveryTime.minute = minute
            this.deliveryTime.day = afterPayDeliveryAt
          }else if(deliveryTimeType === 1){
            this.deliveryTime.deliveryAtAfterPayBefore = deliveryAtAfterPayBefore
          }
        }
        data.itemType = data.itemType || 1;
        data.itemDelivery = itemDelivery;
        this.$set(this, "self_form", data);
      },
      immediate: true,
    },
    'self_form.itemDelivery':{
            handler(formData) {
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(['userInfo', 'bindRelationUrl']),
  },
  methods: {
    method_getFormData(cb) {
      return new Promise((resolve, reject) => {
        this.validPage().then(async (valid) => {
          if (!valid) {
            this.$message.error('请完善表单')
            resolve(false)
            return;
          }
          const [specifications, skuList] = this.getSpecificationData();
          // const c_names = this.$refs.cinput.method_getCategoryNames();
          let _formdata = JSON.parse(JSON.stringify(this.self_form));

          let deliveryTime = ''; // 发货时间
          if(this.isCheckedDeliveryTime){
            const { hour,minute,day,afterPayBefore } = this.deliveryTime
            deliveryTime = {deliveryTimeType:this.deliveryTimeType}
            if(this.deliveryTimeType === 0){
              deliveryTime.payBefore = 3600000 * hour + 60000 * minute
              deliveryTime.afterPayDeliveryAt = day
            }else if(this.deliveryTimeType === 1){
              deliveryTime.deliveryAtAfterPayBefore = afterPayBefore
            }
            deliveryTime = JSON.stringify(deliveryTime)
          }
          _formdata.specifications = specifications;
          _formdata.skuList = skuList                                                                                    
          _formdata.itemDelivery = _formdata.itemDelivery.join(",");
          _formdata.deliveryTime = deliveryTime;
          console.log(_formdata);
          resolve(_formdata);
        });
      });
    },
    // 获取配置
    async getConf() {
        const res = await getDistributionConfig({shopType: 'weidian'});
        this.wdConfig = res;
        // const shopList = this.get_AllShops_BySource('wd');
        let onShelfMap = {
          0:0,
          1:1,
          2:0
        }
        // 上架设置
        let onShelf = (this.self_form.onShelf || this.self_form.onShelf === 0) ? this.self_form.onShelf : (res?.shelfState || 1)
        this.$set(this.self_form, 'onShelf', onShelfMap[onShelf]);
    },
  },
  mounted() {
    this.getConf()
  },
  destroyed() {
  }
};
</script>

<style lang="scss" scoped>
.platform-info-edit-wrp{
  // position: absolute;
  // width: 100%;
  // height: 100%;
  // height: calc(100% - 10px);
  // left: 0;
  // top: 0;
  &.show{
    z-index: 100000;
  }
  &.is-disabled {
    pointer-events: none;
    opacity: 0.6;
    * {
      pointer-events: none;
    }
  }
}
</style>
